import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { ContractDetail } from "@ServerTypes/contracts/contracts.schema";

const contractSlice = createSlice({
  name: "contractDetails",
  initialState: {} as ContractDetail,
  reducers: {
    setContractDetails: (_state: ContractDetail, action: PayloadAction<ContractDetail | undefined>) => ({
      ...(action.payload ?? {}),
    }),
  },
});

export const { setContractDetails } = contractSlice.actions;

export const contractDetails = contractSlice.reducer;

export default contractSlice.reducer;
